export const FirebaseConfig = {
    apiKey: "AIzaSyCrmkSRHVFViMoEa5A5qyPb4ejJcdp6auw",
    authDomain: "kanlaya-c01c8.firebaseapp.com",
    databaseURL: "https://kanlaya-c01c8.firebaseio.com",
    projectId: "kanlaya-c01c8",
    storageBucket: "kanlaya-c01c8.appspot.com",
    messagingSenderId: "553059865420",
    appId: "1:553059865420:web:57f1f34041e8011c9535e9",
    measurementId: "G-LQ8QJQJ5R7"
};